export default ($http) => ({
  async get(id) {
    const { data } = await $http.get(`/v1/products/${id}`);
    return data;
  },
  async list(params) {
    const { data } = await $http.get("/v1/products", { params });
    return data;
  },
});
